// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Renderer package kendi metadata tiplerini tutar.
// UI package'da paralel bir dosya var — ikisi aynı backend kontratına bakar.

export type FieldType =
  | 'String'
  | 'Text'
  | 'RichText'
  | 'Integer'
  | 'Decimal'
  | 'Currency'
  | 'Boolean'
  | 'Date'
  | 'DateTime'
  | 'Time'
  | 'Enum'
  | 'Lookup'
  | 'MultiLookup'
  | 'Email'
  | 'Phone'
  | 'Url'
  | 'File'
  | 'Image'
  | 'Json'
  | 'Html'
  | 'Computed'
  | 'StringList'
  | 'TaggedStringList'
  | 'CheckboxGroup'
  | 'Address'
  | 'ImageGallery';

export type ConfigurationObjectType =
  | 'Catalog'
  | 'Document'
  | 'Register'
  | 'Enumeration'
  | 'Report'
  | 'BusinessProcess'
  | 'ChartOfAccounts'
  | 'AccountingRegister';

export interface LocalizedText {
  readonly [locale: string]: string;
}

export interface FieldDefinition {
  readonly name: string;
  readonly type: FieldType;
  readonly displayName: LocalizedText;
  readonly required?: boolean;
  readonly unique?: boolean;
  readonly maxLength?: number;
  readonly minValue?: number;
  readonly maxValue?: number;
  readonly enumValues?: readonly string[];
  /** Enum degerlerinin yerellestirilmis etiketleri (deger → {tr,en}). Yoksa ham deger gosterilir. */
  readonly enumLabels?: { readonly [value: string]: LocalizedText };
  readonly lookupTarget?: string;
  readonly lookupDisplayField?: string;
  /**
   * Computed alanin sonuc tipi ("currency" | "decimal" | "int" | "bool" | "datetime" | "string").
   * Sunucu bu tipe cevirir; arayuz de AYNI bilgiyi kullanip degeri dogru bicimlendirir
   * (yoksa hesaplanan para alani ham sayi olarak basiliyordu).
   */
  readonly computedResultType?: string;
  /**
   * Dis kod listesi adi (GIB/entegrator listeleri: withholdingTaxCodes, vatExemptionReasonCodes,
   * specialBaseCodes, taxTypeCodes...). Liste entity degil; kayitli cozucuden okunur, boylece
   * kodlar her belgeye kopyalanmaz — tek kaynak.
   */
  readonly codeList?: string;
  /**
   * Bu alan, adi verilen Lookup alaninin hedef kaydindan AYNI ADLA miras alinir
   * (Cari.paymentTermDays -> Fatura.paymentTermDays). Yalniz bossa doldurulur.
   */
  readonly inheritFrom?: string;
  /**
   * InheritFrom hedefindeki KAYNAK alan adi — verilmezse bu alanin adiyla ayni varsayilir
   * (Teklif.termsAndConditions <- DocumentTemplate.content gibi).
   */
  readonly inheritSourceField?: string;
  /** Miras alinan deger, alan DOLU olsa bile uzerine yazilir (sablon secimi). */
  readonly inheritOverwrite?: boolean;
  /** Lookup: hedef kayitlari sabit bir degere gore suzer (kolon adi). */
  readonly lookupFilterField?: string;
  /** LookupFilterField'in eslesmesi gereken sabit deger. */
  readonly lookupFilterValue?: string;
  readonly defaultValue?: string;
  /** Lookup: yeni kayıtta hedef katalogun isDefault=true satırını otomatik ön-doldur (ratingId → "Ilık"). */
  readonly autoDefault?: boolean;
  /**
   * Lookup: sonuçları AYNI formdaki başka bir alanın (genelde currentAccountId/customerId) güncel
   * değerine göre filtreler — örn. Fatura'da Sözleşme sadece seçili Cari Hesap'a ait sözleşmeleri
   * gösterir. Hedef entity'deki filtre kolonu varsayılan olarak BU ALANLA AYNI isimdedir;
   * farklıysa filterByTargetField ile belirtilir (örn. SalesOrder.customerId → AccountContract.currentAccountId).
   */
  readonly filterByField?: string;
  /** filterByField'in hedef entity'deki karşılık geldiği kolon adı — belirtilmezse filterByField ile aynı varsayılır. */
  readonly filterByTargetField?: string;
  /**
   * Lookup: seçilen kaydın "currency" alanı, formdaki BU ADLI kardeş alana otomatik yazılır — örn.
   * Fatura'da Sözleşme seçilince o sözleşmenin PB'si Invoice.currency'ye aktarılır (mevcut currency+
   * exchangeRate otomasyonu — bkz. FormRenderer fxFields — devreye girip günün kurunu gösterir).
   */
  readonly syncCurrencyToField?: string;
  /**
   * Image: ek resimler bu adli kardes ImageGallery alaninda tutulur. Widget kapak + digerlerini tek
   * kutuda gezilebilir gosterir; kapak bu alanda kalir (liste kucuk resmi, fatura satiri, mobil okur).
   */
  readonly galleryField?: string;
  readonly description?: LocalizedText;
  readonly isPii?: boolean;
  readonly placeholder?: LocalizedText;
  readonly helpText?: LocalizedText;
  readonly readOnly?: boolean;
  /** Formda HİÇ çizilmez — teknik/sistem içi alan (ör. ham "Karşı Hesap Id"). Veri korunur. */
  readonly hiddenInForm?: boolean;
  /** Baska bir alandan onBlur'da otomatik kopyalama (name → shortName patterni). */
  readonly autoFillFrom?: string;
  /** Format patterni — "phone-tr", "phone-intl", "iban-tr", "vkn-tr", "tckn-tr" vb. */
  readonly format?: string;
  /** Sadece bu ulke kodlari icin gorunur (aktif tenant country'si eslesmeli). Bos ise her zaman gorunur. */
  readonly visibleWhenCountry?: readonly string[];
  /** 2-kolon inline grid'de (StringList/TaggedStringList icin). */
  readonly inlineGrid?: 1 | 2 | 3 | 4;
  /** TaggedStringList icin tag secenekleri (backend NestedListDefinition.Tags muadili ama field-level). */
  readonly tags?: readonly string[];
  /** Sol prefix ikon adi (lucide isim veya emoji). */
  readonly iconName?: string;
  /** Prefix ikon rengi (Tailwind text-xxx-yyy sinifi). */
  readonly iconColor?: string;
  /** Lookup'ta yanina + butonu ekle (hizli yeni kayit icin modal). Target entity adi. */
  readonly quickCreateTarget?: string;
  /** Liste grid'inde baslangic kolon genisligi (px) — eportal sWidth muadili. Kullanici resize edince localStorage kazanir. Yoksa 150. */
  readonly columnWidth?: number;
  /** Enum kolonunda rozetin yanina ayni satirdan baska bir alanin degerini kucuk/soluk metin olarak ekler (orn. Durum=Gonderildi yaninda e-Fatura No). Deger bossa hicbir sey eklenmez. */
  readonly badgeDetailField?: string;
}

// UI layout konfigurasyonu — metadata'da opsiyonel.
// Yoksa renderer mantıklı bir varsayılan kullanır.

export type ColumnSpan = 1 | 2 | 3 | 4 | 6 | 12;

export interface FormFieldPlacement {
  readonly fieldName: string;
  readonly colSpan?: ColumnSpan;
  /**
   * Alan bu kiracıda zorunlu DEĞİLSE (tanım zorunlu der ama firma ayarı gevşetmiştir; metadata
   * ucu `required: false` döner) formun başında durmasın, buraya insin. Zorunluyken yerinde kalır.
   * Örnek: stok kodu kullanmayan firmada "Stok Kodu" ürün adının önünde durmaz.
   */
  readonly whenOptional?: {
    /** Hedef bölüm kimliği (hangi sekmede olursa olsun). */
    readonly section: string;
    /** Bu alanın hemen arkasına; yoksa bölümün sonuna. */
    readonly after?: string;
  };
}

export interface FormSection {
  readonly id: string;
  readonly title?: LocalizedText;
  readonly description?: LocalizedText;
  readonly columns?: 1 | 2 | 3 | 4;
  readonly fields: readonly (string | FormFieldPlacement)[];
  readonly collapsible?: boolean;
  readonly collapsedByDefault?: boolean;
  /**
   * Bir collection'i bu section icinde inline goster (General tab pattern'i).
   * Collection yine ayrica kendi tab'inda da gozukur — burada compact/preview olarak ekli.
   */
  readonly embeddedCollection?: string;
  /**
   * Bu section'in yerine, belirtilen Grid/Table koleksiyonunun TAM kalem izgarasini
   * (CollectionTab + alt-toplam/settlement) bu konumda render et. Boylece kalem izgarasi
   * formun en sonu yerine istenen bolumun (orn. Yasal Bilgiler) altina alinabilir.
   * Bu placeholder kullanildiginda izgara artik tab sonunda mukerrer cizilmez.
   */
  readonly collectionGrid?: string;
  /**
   * 2-kolonlu tab layout'unda section'in hangi tarafta olacagi ("primary-info | contact-info" patterni).
   * Tab icindeki herhangi bir section'da 'left' veya 'right' varsa, tab 2-kolonlu grid'e ceker:
   *   left sectionlar sol kolonda yukaridan asagiya,
   *   right sectionlar sag kolonda yukaridan asagiya.
   * Yok veya 'full' ise tam genislik.
   */
  readonly side?: 'left' | 'right' | 'full';
  /**
   * Renkli baslik aksan cubugu (border-cyan-400 pattern'i). Tailwind sinifi.
   * Orn. "border-orange-400", "border-emerald-500", "border-cyan-400".
   */
  readonly accentColor?: string;
  /**
   * Gorsel stil. "glass" = glassmorphism kart (info-card patterni),
   * "flat" = standart (default).
   */
  readonly cardStyle?: 'glass' | 'flat';
  /**
   * Section basligi yaninda (sagda) inline render edilecek field adi.
   * Orn. "isCorporate" → "Vergi ve Yasal Bilgiler" basligin sag kenarinda Tuzel Kisi checkbox'i.
   */
  readonly headerField?: string;
}

export interface FormTab {
  readonly id: string;
  readonly title: LocalizedText;
  readonly sections: readonly FormSection[];
}

/** Belge seviyesindeki eylem dugmeleri (Revize Et gibi) — form basliginda cizilir. */
export interface DocumentAction {
  readonly label: LocalizedText;
  readonly endpoint: string;
  readonly confirm?: LocalizedText | undefined;
}

export interface FormUiConfig {
  readonly tabs?: readonly FormTab[];
  readonly sections?: readonly FormSection[];
}

export interface ListFilterDef {
  readonly field: string;
  readonly label?: LocalizedText;
  readonly op?: 'eq' | 'in' | 'contains' | 'gte' | 'lte' | 'between';
  readonly defaultValue?: unknown;
}

/**
 * Sol cam çekmecede gösterilecek kategori/grup ağacı.
 * Ağaç ayrı bir self-referans katalogdan gelir (örn. Cari→CustomerGroup, Stok→InventoryCategory).
 * Düğüme tıklayınca liste, bu entity'deki `field` üzerinden o düğüme (ve istenirse alt düğümlerine) süzülür.
 */
export interface ListHierarchyConfig {
  /** Bu entity'deki grup/kategori lookup alanı (örn. mainGroupId / categoryId). */
  readonly field: string;
  /** Ağacı tutan katalog adı (örn. CustomerGroup / InventoryCategory). */
  readonly catalog: string;
  /** Katalogdaki üst-düğüm alanı (örn. parentGroupId / parentId). */
  readonly parentField: string;
  /** Düğüm etiketi alanı; yoksa name/nameValue/code otomatik denenir. */
  readonly labelField?: string;
  /** Bir düğüm seçilince alt düğümleri de süzmeye dahil et (varsayılan true). */
  readonly includeDescendants?: boolean;
  /** Çekmece başlığı. */
  readonly title?: LocalizedText;
}

export interface ListUiConfig {
  readonly visibleColumns?: readonly string[];
  /**
   * Dar ekranda kolon önceliği: önem sırasıyla alan adları. Yer yetmeyince en düşük öncelikli kolon alt satıra
   * ("+") düşer; ekrandaki sıra değişmez. Verilmezse öncelik = ekran sırası (lib/kolonTasmasi).
   */
  readonly columnPriority?: readonly string[];
  readonly defaultSort?: { readonly field: string; readonly direction: 'asc' | 'desc' };
  /** Tanım dosyaları alan adını düz metin olarak yazar ("filters": ["currency"]); ayrıntı gerekirse nesne. */
  readonly filters?: readonly (string | ListFilterDef)[];
  readonly pageSize?: number;
  readonly rowActions?: readonly ('edit' | 'delete')[];
  readonly bulkActions?: readonly ('delete')[];
  readonly hierarchy?: ListHierarchyConfig;
}

export interface RelatedListDef {
  readonly id: string;
  readonly title: LocalizedText;
  readonly targetObject: string;
  readonly targetApp?: string;
  readonly foreignKey: string;
  readonly visibleColumns?: readonly string[];
}

export interface DetailUiConfig {
  readonly inlineEdit?: boolean;
  readonly relatedLists?: readonly RelatedListDef[];
  readonly showActivityFeed?: boolean;
  readonly sidebarFields?: readonly string[];
  readonly compactHeader?: CompactHeaderConfig;
  readonly activityPanel?: ActivityPanelConfig;
}

/** SAP Fiori compact header — kart ustunde kod+ad+tag+metrik ozeti. */
export interface CompactHeaderConfig {
  /** Ust satir: sol — "Kod" tag'i (monospace blue) */
  readonly codeField?: string;
  /** Ust satir: sol — buyuk baslik alani */
  readonly titleField?: string;
  /** Ust satir: sag — tag'ler (CheckboxGroup/Enum deger bazli) */
  readonly tags?: readonly CompactHeaderTag[];
  /** Alt satir: inline metrik kartlari (bakiye/limit/risk) */
  readonly metrics?: readonly CompactHeaderMetric[];
}

export interface CompactHeaderTag {
  readonly field: string;
  /** value → { label, color } haritasi (color: blue/green/orange/red/violet/gray) */
  readonly map?: Record<string, { label: string; color: string }>;
}

export interface CompactHeaderMetric {
  readonly field: string;
  readonly label: string;
  readonly format?: 'currency' | 'number' | 'percent' | 'text';
  /** currency format icin para birimi kaynagi alanı (yoksa "TRY") */
  readonly currencyField?: string;
  readonly icon?: string;
  readonly color?: string;
  /** positive/negative color: sayisal alanlar icin 0'a gore renklendir */
  readonly positiveColor?: string;
  readonly negativeColor?: string;
}

/** SAP Fiori sol aktivite paneli — Call/Email/Meeting kayit + timeline */
export interface ActivityPanelConfig {
  readonly enabled: boolean;
  readonly allowCall?: boolean;
  readonly allowEmail?: boolean;
  readonly allowMeeting?: boolean;
  readonly allowFollow?: boolean;
}

export interface DynamicLogicCondition {
  readonly type: 'equals' | 'notEquals' | 'in' | 'notIn' | 'isNotEmpty' | 'isEmpty' | 'greaterThan' | 'lessThan';
  readonly attribute: string;
  readonly value?: unknown;
}

export interface DynamicLogicRule {
  readonly conditionGroup: readonly DynamicLogicCondition[];
}

export interface DynamicLogicFieldRules {
  readonly visible?: DynamicLogicRule;
  readonly required?: DynamicLogicRule;
  readonly readOnly?: DynamicLogicRule;
}

export interface DynamicLogicConfig {
  readonly fields?: Record<string, DynamicLogicFieldRules>;
}

export interface KanbanConfig {
  readonly enabled: boolean;
  readonly statusField: string;
  readonly orderField?: string;
}

export interface UiConfig {
  readonly form?: FormUiConfig;
  /** Belge seviyesi eylemleri (Revize Et gibi) — EntityFormPanel basliginda cizilir. */
  readonly documentActions?: readonly DocumentAction[];
  /** Kayıt e-Belge olarak gönderilebilir (hemen / ileri saatte). Uç, /api/{tenant}/{app}/ altına göre: "invoice/{id}/ebelge". */
  readonly ebelgeSend?: { readonly endpoint: string };
  readonly list?: ListUiConfig;
  readonly detail?: DetailUiConfig;
  readonly formMode?: 'slide' | 'modal' | 'inline';
  readonly color?: string;
}

export type Cardinality = 'OneToOne' | 'OneToMany' | 'ZeroToMany';
export type CollectionLayout = 'CardList' | 'Grid' | 'Table' | 'Modal' | 'Variant';
export type DeletionMode = 'Soft' | 'Reversal' | 'HardAdminOnly' | 'NeverDelete';

export interface NestedListDefinition {
  readonly name: string;
  readonly type: 'StringList' | 'TaggedStringList';
  readonly icon?: string;
  readonly tags?: readonly string[];
  readonly validationPattern?: string;
  readonly displayName?: LocalizedText;
  readonly minCount?: number;
  readonly maxCount?: number | null;
}

export interface PrimaryFlag {
  readonly field: string;
  readonly default: boolean;
}

export interface DeletionPolicyInfo {
  readonly mode: DeletionMode;
  readonly statusField: string;
  readonly activeValue: number;
  readonly deletedValue: number;
  readonly archivedValue: number;
  readonly recycleBinDays: number;
  readonly hardDeleteAfterDays: number;
  readonly reversalReferenceField: string;
  readonly reversalReasonRequired: boolean;
  readonly allowedRolesToRestore: readonly string[];
  readonly allowedRolesToHardDelete: readonly string[];
  readonly gdprErasureOverride: boolean;
}

export interface CollectionDefinition {
  readonly name: string;
  readonly displayName?: LocalizedText;
  readonly icon?: string;
  readonly target: string;
  readonly parentField: string;
  readonly cardinality: Cardinality;
  readonly ordering?: string;
  readonly summaryFields?: readonly string[];
  readonly primary?: PrimaryFlag | null;
  readonly minCount?: number;
  readonly maxCount?: number | null;
  readonly defaultLayout: CollectionLayout;
  readonly allowBulkAdd?: boolean;
  readonly deletion?: DeletionPolicyInfo | null;
  readonly nested?: readonly NestedListDefinition[];
  /**
   * Kalem izgarasindaki "Doldur" — 1C'de Fiziksel stok / Stok transferi kalem cubugundaki islevin
   * karsiligi. Satirlari kaynaktan (stok bakiyesi, siparis kalemleri, fiyat listesi...) doldurur.
   * `endpoint` icindeki {id} kaydedilmis belge id'si ile degistirilir; belge KAYDEDILMEDEN calismaz.
   *
   * 1C'de CANLI dogrulandi (2026-08-01, Fiziksel stok formu): "Doldur" TEK dugme DEGIL, dort secenekli
   * ACILIR MENU — Stoktaki urunler / Muhasebe verisi / Fiyat turune gore fiyatlar / Sayilan miktari
   * temizle. Bu yuzden liste: tek eylemde duz dugme, cok eylemde acilir menu cizilir.
   */
  readonly fillActions?: readonly FillAction[] | null;
  /**
   * Kalem izgarasina DOSYADAN satir aktarma (banka ekstresi gibi). "Doldur"dan farki: veri
   * kaynagi sunucuda degil, kullanicinin dosyasinda — bu yuzden dosya secici acilir ve
   * multipart gonderilir. Ayristirma sunucuda (tek yerde), arayuz dosyayi tasir.
   */
  readonly uploadActions?: readonly UploadAction[] | null;
}

/** Kalem izgarasina dosyadan satir aktaran eylem. */
export interface UploadAction {
  readonly label: LocalizedText;
  readonly endpoint: string;
  /** Dosya seciciye verilen kabul listesi (".csv,.txt"). Bos ise tum dosyalar. */
  readonly accept?: string;
}

/** Kalem izgarasi "Doldur" menusundeki tek bir eylem. */
export interface FillAction {
  readonly label: LocalizedText;
  readonly endpoint: string;
  readonly confirm?: LocalizedText;
  /** Satirlari sifirlayan eylem (1C "Sayilan miktari temizle") — onay istenir, yikici gorunur. */
  readonly destructive?: boolean;
  /**
   * Doluysa eylem ONCE secim ister: belirtilen belge izgarada coklu secim kipinde acilir,
   * secilen kayitlarin id'leri uca govdede gider (or. birden fazla siparisi tek faturaya toplama).
   */
  readonly picker?: FillActionPicker | null;
}

/** "Doldur" eyleminin secim ekrani tarifi. */
export interface FillActionPicker {
  readonly object: string;
  readonly title?: LocalizedText;
  /** Hedef entity'de suzulecek alan (or. customerId). */
  readonly filterField?: string;
  /** Degerin okunacagi ACIK belgenin alani (or. currentAccountId). */
  readonly filterFromField?: string;
}

export interface ConfigurationObject {
  readonly name: string;
  readonly type: ConfigurationObjectType;
  readonly appName: string;
  readonly schemaVersion: number;
  readonly displayName: LocalizedText;
  readonly pluralDisplayName?: LocalizedText;
  readonly icon?: string;
  readonly description?: LocalizedText;
  readonly tenantCode: string;
  readonly fields: readonly FieldDefinition[];
  readonly ui?: UiConfig;
  readonly dynamicLogic?: DynamicLogicConfig;
  readonly kanban?: KanbanConfig;
  readonly stream?: boolean;
  readonly collections?: readonly CollectionDefinition[];
  readonly deletion?: DeletionPolicyInfo;
}

export type EntityRow = Record<string, unknown>;

/**
 * Aktif arayüz dili — <html lang> üzerinden okunur.
 *
 * Renderer paketi i18next'e bağlı DEĞİL (çekirdek dışı bir bağımlılık istemiyoruz); i18n katmanı
 * dili zaten belgeye yazıyor, burası onu okur. Varsayılanı 'tr' bırakmak, arayüz İngilizceyken
 * bütün kolon başlıklarını ve entity adlarını Türkçe bırakıyordu (2026-08-29, satış listesi).
 */
export function aktifDil(): string {
  if (typeof document === 'undefined') return 'tr';
  return (document.documentElement.lang || 'tr').split('-')[0] ?? 'tr';
}

export function localized(text: LocalizedText | undefined, locale?: string, fallback = ''): string {
  if (!text) return fallback;
  const dil = locale ?? aktifDil();
  return text[dil] ?? text['en'] ?? text['tr'] ?? fallback;
}

/** Enum degerini yerellestirilmis etikete cevirir; enumLabels yoksa ham degeri dondurur (geriye donuk uyumlu). */
export function enumLabel(field: FieldDefinition, value: string, locale?: string): string {
  if (!value) return value;
  const map = field.enumLabels?.[value];
  return map ? localized(map, locale, value) : value;
}
